import dayjs from '@/lib/dayjs'
import { getErrorMessage } from '@/lib/utils'
import { PRICE_ADJUSTMENT_WHEN_TYPE_PERMANENT } from '@/lib/services/price-adjustments/priceAdjustments.schema'
import { getPriceAdjustmentScheduleSummary } from '@/lib/services/price-adjustments/priceAdjustments.summary'

export const getWhenTypeSummary = (adjustment) => {
  if (adjustment?.when_type === PRICE_ADJUSTMENT_WHEN_TYPE_PERMANENT) {
    return 'Updates matching product prices permanently when saved.'
  }

  return getPriceAdjustmentScheduleSummary(adjustment)
}

export const getPriceAdjustmentErrorMessage = (error) => {
  const fieldErrors = Object.values(error?.response?.data?.errors ?? {})
    .flat()
    .filter(Boolean)

  return fieldErrors[0] ?? getErrorMessage(error)
}

export const getPriceAdjustmentScheduleBounds = (initialData) => {
  if (initialData) {
    return {
      minDate: null,
      maxDate: null,
    }
  }

  return {
    minDate: dayjs().startOf('day'),
    maxDate: dayjs().add(1, 'year').endOf('year'),
  }
}
